import type { ButtonProps } from 'components/Button/Button'
import { Button } from 'components/Button/Button'
import type { FC } from 'react'
import { colors } from 'settings/colors'

type WideFooterProps = {
  primaryButtonAsync?: ButtonProps['async']
  primaryButtonAsyncOptions?: ButtonProps['asyncOptions']
  primaryButtonDisabled?: boolean
  primaryButtonText?: string
  primaryButtonOnPress?: () => void
  secondaryButtonDisabled?: boolean
  secondaryButtonText?: string
  secondaryButtonOnPress?: () => void
  secondaryButtonVariant?: ButtonProps['variant']
}

export const WideFooter: FC<WideFooterProps> = ({
  primaryButtonAsync,
  primaryButtonAsyncOptions,
  primaryButtonDisabled,
  primaryButtonText,
  primaryButtonOnPress,
  secondaryButtonDisabled,
  secondaryButtonText,
  secondaryButtonOnPress,
  secondaryButtonVariant = 'tertiary',
}) => {
  const noPrimaryAndSecondaryTextPassed = !primaryButtonText && !secondaryButtonText

  if (noPrimaryAndSecondaryTextPassed) return <div />

  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: `1px solid ${colors.grey200}`,
        backgroundColor: colors.grey50,
        padding: '8px',
        alignItems: 'center',
      }}
    >
      {secondaryButtonText ? (
        <Button
          disabled={!!secondaryButtonDisabled}
          variant={secondaryButtonVariant}
          onClick={secondaryButtonOnPress}
        >
          {secondaryButtonText}
        </Button>
      ) : (
        <div />
      )}
      {primaryButtonText ? (
        <Button
          async={primaryButtonAsync}
          asyncOptions={primaryButtonAsyncOptions}
          disabled={!!primaryButtonDisabled}
          variant="primary"
          onClick={primaryButtonOnPress}
        >
          {primaryButtonText}
        </Button>
      ) : (
        <div />
      )}
    </div>
  )
}
